import axios from "axios";
import { atualUfDefinition, EnumAmbienteTipos } from "../../../helpers/utils";

function isLocalhost() {
  const currentHost = window.location.hostname || "";
  return currentHost === "localhost" || currentHost === "127.0.0.1";
}

function resolveBaseUrl() {
  if (isLocalhost()) {
    if (atualUfDefinition && atualUfDefinition.env) {
      return atualUfDefinition.env;
    }

    return process.env.VUE_APP_BASE_API_LOCAL || "http://localhost:64332/";
  }

  if (atualUfDefinition && atualUfDefinition.env) {
    return atualUfDefinition.env;
  }

  return process.env.VUE_APP_BASE_API_CE_HLG || "";
}

export function resolveBanco() {
  const params = new URLSearchParams(window.location.search || "");
  const bancoParam = params.get("banco");

  if (bancoParam) {
    localStorage.setItem("analiseEvidenciasIaBanco", bancoParam);
    return bancoParam;
  }

  if (atualUfDefinition && atualUfDefinition.banco) {
    return atualUfDefinition.banco;
  }

  if (isLocalhost()) {
    return "selo-rj-hlg";
  }

  return localStorage.getItem("analiseEvidenciasIaBanco") || "";
}

function resolveBranch() {
  const params = new URLSearchParams(window.location.search || "");
  const branchParam = params.get("branch");
  if (branchParam) return branchParam;

  if (atualUfDefinition && atualUfDefinition.ambient === EnumAmbienteTipos.prod) {
    return "main";
  }

  return "hlg";
}

const api = axios.create({
  baseURL: resolveBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers = config.headers || {};
  config.headers["banco"] = resolveBanco();
  config.headers["branch"] = resolveBranch();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

export const analiseEvidenciasIaApi = {
  async obterPainel(params) {
    const { data } = await api.get("/api/IaAnaliseEvidencias/painel", { params });
    return data;
  },

  async obterFiltros() {
    const { data } = await api.get("/api/IaAnaliseEvidencias/filtros");
    return data;
  },

  async obterRuntime() {
    const { data } = await api.get("/api/IaAnaliseEvidencias/runtime");
    return data;
  },

  async preview(payload) {
    const { data } = await api.post("/api/IaAnaliseEvidencias/preview", payload);
    return data;
  },

  async criarExecucao(payload) {
    const { data } = await api.post("/api/IaAnaliseEvidencias/execucoes", payload);
    return data;
  },

  async criarExecucaoPendente(payload) {
    const { data } = await api.post("/api/IaAnaliseEvidencias/execucoes/criar-pendente", payload);
    return data;
  },

  async processarExecucaoLote(id, payload, limite = 10) {
    const { data } = await api.post(
      `/api/IaAnaliseEvidencias/execucoes/${encodeURIComponent(id)}/processar-lote`,
      payload,
      { params: { limite } },
    );
    return data;
  },

  async registrarDecisao(id, payload) {
    const { data } = await api.post(`/api/IaAnaliseEvidencias/itens/${encodeURIComponent(id)}/decisao`, payload);
    return data;
  },

  async sincronizarItem(id, origemTela) {
    const { data } = await api.post(`/api/IaAnaliseEvidencias/itens/${encodeURIComponent(id)}/sincronizar`, { origemTela });
    return data;
  },

  async sincronizarDecididas(payload) {
    const { data } = await api.post("/api/IaAnaliseEvidencias/sincronizar", payload);
    return data;
  },

  downloadEvidencia(id) {
    return api.post(`/api/arquivo/evidencia/download/${encodeURIComponent(id)}`, null, {
      responseType: "blob",
    });
  },

  downloadIaArquivo(id) {
    return api.get(`/api/IaColetaEvidencias/arquivos/${encodeURIComponent(id)}/download`, {
      responseType: "blob",
    });
  },

  exportarResultados(params) {
    return api.get("/api/IaAnaliseEvidencias/exportar", {
      params,
      responseType: "blob",
    });
  },

  exportarResultadosPdf(params) {
    return api.get("/api/IaAnaliseEvidencias/exportar-pdf", {
      params,
      responseType: "blob",
    });
  },

  async listarRegras(params) {
    const { data } = await api.get("/api/IaAnaliseEvidencias/regras", { params });
    return data;
  },

  async salvarRegra(payload) {
    const id = payload && payload.analiseEvidenciasIaRegraId;
    if (id) {
      const { data } = await api.put(`/api/IaAnaliseEvidencias/regras/${encodeURIComponent(id)}`, payload);
      return data;
    }

    const { data } = await api.post("/api/IaAnaliseEvidencias/regras", payload);
    return data;
  },

  async desativarRegra(id) {
    const { data } = await api.post(`/api/IaAnaliseEvidencias/regras/${encodeURIComponent(id)}/desativar`);
    return data;
  },
};
